import { render, staticRenderFns } from "./KusClientAccessRight.vue?vue&type=template&id=6ccd7ff0"
import script from "./KusClientAccessRight.vue?vue&type=script&lang=js"
export * from "./KusClientAccessRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports